import { Outlet } from "react-router-dom";
import { Navigation } from "./navigation";
import { ChatAiSidebar } from "./ChatAiSidebar";

const Layout = () => {
  return (
    <>
      <Navigation />
      <Outlet />
      <ChatAiSidebar />
    </>
  );
};

export default Layout;
